/**************************************************
 * Nombre:       Cabecera_Crm
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, IconButton, InputAdornment, TextField, Typography, useMediaQuery} from "@mui/material";
import {Add, ChevronLeft, ChevronRight, Search} from "@mui/icons-material";
import {theme} from "../../Tema";
import {ANCHOCOLUMNA} from "../Constantes";
import {useDialogo} from "../../Modulo_Dialogos_2025/Hooks/useDialogo";
import Dialogo_Lead from "../Dialogos/Dialogo_Lead";
import {useEffect, useState} from "react";
import {contarWheres} from "../../Servicios/BD/Contadores/contarWheres";
import {where} from "firebase/firestore";
import dayjs from "dayjs";


const Cabecera_Crm = ({refe, verActividadesHoy, verSinActividades, escogido,verTodos}) => {
    const sCell = useMediaQuery(theme.breakpoints.only("xs"));
    const {Dialogo, abrir} = useDialogo({Componente: Dialogo_Lead, titulo: 'Detalles Lead'});
    const [numActHoy, setNumActHoy] = useState(0);
    const [numNoAct, setNumNoAct] = useState(0);


    const manejoScroll = (direction) => {
        if (refe.current) {
            const scrollAmount = 300; // La cantidad de píxeles que avanzará por click

            if (direction === 'left') {
                refe.current.scrollBy({left: -scrollAmount, behavior: 'smooth'});
            } else {
                refe.current.scrollBy({left: scrollAmount, behavior: 'smooth'});
            }
        }
    };

    const obtenerNumActHoy = async () => {

        let hoyInicio = dayjs().set('hours', 0).set('minutes', 1).valueOf();
        let hoyFin = dayjs().set('hours', 23).set('minutes', 59).valueOf();
        let w = [where('fechaProximoContacto', '>=', hoyInicio), where('fechaProximoContacto', '<=', hoyFin)]
        let num = await contarWheres({coleccion: 'potenciales', wheres: w})
        setNumActHoy(num.data)

    }

    const obtenerNumSinAct = async () => {

        let w = [where('fechaProximoContacto', '==', null)]
        let num = await contarWheres({coleccion: 'potenciales', wheres: w})
        setNumNoAct(num.data)

    }



    useEffect(() => {

        obtenerNumActHoy().then();
        obtenerNumSinAct().then();

    }, []);
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'center'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{px: 0}}
            spacing={2}
        >

            <Dialogo/>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}>

                <TextField fullWidth={false} variant={'outlined'} label={'Buscar'} size={'small'}
                           sx={{
                               width: sCell ? '100%' : ANCHOCOLUMNA
                           }}
                           slotProps={{
                               input: {
                                   endAdornment: (
                                       <InputAdornment position="end">
                                           <IconButton
                                               // onClick={() => click()}
                                               sx={{
                                                   backgroundColor: theme.palette.primary.main, borderRadius: 1,
                                                   "&:hover": {
                                                       backgroundColor: theme.palette.secondary.main
                                                   },
                                                   mr: -1.5,
                                                   boxShadow: 0

                                               }}>
                                               <Search sx={{fill: '#fff', width: 20, height: 20}}/>
                                           </IconButton>
                                       </InputAdornment>
                                   ),
                                   disableUnderline: true,
                               },
                               inputLabel: {
                                   sx: {marginLeft: -0.9}
                               }
                           }}
                />

                <Typography sx={{color: theme.palette.info.main + 90}}>Filtros: </Typography>

                <Button
                    onClick={() => abrir()}
                    variant={'outlined'}>
                    <Add/>
                </Button>

            </Grid>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}>

                <Grid container size={{xs: 12, sm: 9, md: 10}} sx={{justifyContent: 'flex-start'}} spacing={2}>

                    <Button onClick={() => verTodos()}
                            variant={escogido === 'Todos' ? 'contained' : 'outlined'}
                            sx={{borderRadius: 6, px: 3, boxShadow: 0}}

                    >Todos</Button>

                    <Button onClick={() => verActividadesHoy()}
                            variant={escogido === 'Hoy' ? 'contained' : 'outlined'}
                            sx={{borderRadius: 6, px: 3, boxShadow: 0}}
                    >{`${numActHoy} / Actividades Hoy`}</Button>

                    <Button onClick={() => verSinActividades()}
                            variant={escogido === 'Sin' ? 'contained' : 'outlined'}
                            sx={{borderRadius: 6, px: 3, boxShadow: 0}}
                    >{`${numNoAct} / Sin Actividades`}</Button>
                </Grid>

                <Grid container size={{xs: 12, sm: 3, md: 2}} sx={{justifyContent: 'flex-end'}} spacing={1}>
                    <IconButton
                        onClick={() => manejoScroll('left')}
                        sx={{
                            backgroundColor: theme.palette.primary.main,
                            '&:hover': {
                                backgroundColor: theme.palette.primary.main + 60,
                            }
                        }}
                    >
                        <ChevronLeft sx={{fill: '#fff'}}/>
                    </IconButton>

                    <IconButton
                        onClick={() => manejoScroll('right')}
                        sx={{
                            backgroundColor: theme.palette.primary.main,
                            '&:hover': {
                                backgroundColor: theme.palette.primary.main + 60,
                            }
                        }}
                    >
                        <ChevronRight sx={{fill: '#fff'}}/>
                    </IconButton>
                </Grid>

            </Grid>


        </Grid>
    )

}
export default Cabecera_Crm    